import {isUndefined} from '@yandex-delivery/utils'
import type {PromoBannerButton} from 'src/api/types'
import {config} from 'src/shared/config'
import {Brand} from 'src/shared/types'

import {BannerView} from './PromoBanner.consts'

const getDownloadYandexAppWithOffer = (promoCode: string) =>
  `https://8jxm.adj.st/addpromocode?code=${promoCode}&adj_t=ivdp40_fxy409&&adj_campaign=ALL-ALL-ALL&adj_adgroup=share-route-card&adj_creative=newbanner-offer&adj_deep_link=yandextaxi%3A%2F%2Faddpromocode%3Fcode%3D${promoCode}`

const getDownloadYangoAppWithOffer = (promoCode: string) =>
  `https://u9xb.adj.st/addpromocode?code=${promoCode}&adj_t=ivdp40_fxy409&&adj_campaign=ALL-ALL-ALL&adj_adgroup=share-route-card&adj_creative=newbanner-offer&adj_deep_link=yandextaxi%3A%2F%2Faddpromocode%3Fcode%3D${promoCode}`

const getDownloadYandexAppWithoutOffer = () =>
  'https://8jxm.adj.st/route?tariffClass=express&adj_t=ivdp40_fxy409&&adj_campaign=ALL-ALL-ALL&adj_adgroup=share-route-card&adj_creative=newbanner&adj_deep_link=yandextaxi%3A%2F%2Froute%3FtariffClass%3Dexpress'

const getDownloadYangoAppWithoutOffer = () =>
  'https://yango.go.link?adj_t=1fth5c10_1fy2neeo&adj_campaign=default_27_08_2024'

const APP_LINK_GETTERS_MAP: Readonly<Record<BannerView, Record<Brand, (promoCode: string) => string>>> = {
  [BannerView.WITH_LEAD_BUTTON]: {
    [Brand.Yango]: getDownloadYangoAppWithOffer,
    [Brand.Yandex]: getDownloadYandexAppWithOffer,
  },
  [BannerView.WITHOUT_LEAD_BUTTON]: {
    [Brand.Yango]: getDownloadYangoAppWithoutOffer,
    [Brand.Yandex]: getDownloadYandexAppWithoutOffer,
  },
} as const

export const usePromoBannerAppLinkByVew = (bannerView: BannerView, promoCode = '', deeplink?: string) => {
  return deeplink || APP_LINK_GETTERS_MAP[bannerView][config.brand === 'yango' ? 'yango' : 'yandex'](promoCode)
}

export const usePromoBannerType = (leadButton?: PromoBannerButton) =>
  isUndefined(leadButton) ? BannerView.WITHOUT_LEAD_BUTTON : BannerView.WITH_LEAD_BUTTON
